import { Grid } from '@mui/material'
import AutocompleteList from '../../../shared/UI/AutocompleteList'
import Alert from '../../../shared/UI/Alert/Alert'
import { Employee } from '../../../services/dashboardService'

interface EmployeePickerProps {
  employees: Employee[]
  selectedEmployee?: Employee
  disabled: boolean
  setSelectedEmployee: (value: Employee | undefined) => void
  error?: boolean
}

function EmployeePicker({
  employees,
  selectedEmployee,
  disabled,
  setSelectedEmployee,
  error = false
}: EmployeePickerProps) {
  return (
    <>
      <Grid item xs={12}>
        <AutocompleteList
          id="employee"
          label="Employee"
          data={employees}
          textField="employeeName"
          value={selectedEmployee}
          onChange={(event, employee) => {
            setSelectedEmployee(employee)
          }}
          error={error}
          helperText={!selectedEmployee ? 'Required' : ''}
          dataTestId="MyActions-Absence-Employee"
          disabled={disabled}
        />
        {!selectedEmployee && (
          <Grid item mt={2}>
            <Alert severity="info" message="Select Employee" />
          </Grid>
        )}
      </Grid>
    </>
  )
}

export default EmployeePicker
